export default "__VITE_ASSET__scZS35D1__"